import { format, parseISO, isValid } from 'date-fns';
import { adjustDateForTimezone } from 'helpers/intl-fns';

/**
 * Formats a reservation name. If the name is an ISO timestamp string,
 * formats it as a readable date/time string (in the venue timezone when one
 * is provided). Otherwise, returns the name as-is.
 *
 * @param {string} name - The reservation name or ISO timestamp string
 * @param {string} [timezone] - IANA venue timezone for the formatted output
 * @returns {string} Formatted date string or original name
 */
export const formatReservationName = (name, timezone) => {
  if (!name) return '';
  const date = parseISO(name);
  if (!isValid(date)) return name;
  const adjusted = timezone ? adjustDateForTimezone(date, timezone) : date;
  return format(adjusted, "MMMM d, yyyy 'at' h:mm a");
};
